<template>
    <el-drawer
        :title="detailData.title"
        :visible.sync="detailParam.visible"
        size="520px"
        :close-on-press-escape="false"
        :wrapperClosable="false"
    >
        <div class="drawer-wrapper">
            <div class="drawer-main" v-loading="detailData.loading.main">
                <div class="drawer-body">
                    <el-form :model="detailData" ref="detailData" size="small">
                        <el-form-item label="物流方式：">
                            <el-select v-model="detailData.row.express_type">
                                <el-option-group
                                    :key="group.label"
                                    :label="group.label"
                                    v-for="group in $store.state.expressInfo.list"
                                >
                                    <el-option
                                        :key="item.key"
                                        :label="item.value"
                                        :value="item.key"
                                        v-for="item in group.options"
                                    ></el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                        <el-row :gutter="10">
                            <el-col :span="8" v-if="detailData.row.express_type === 12">
                                <el-form-item>
                                    <el-input
                                        v-model="detailData.row.express_name"
                                        placeholder="物流公司"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="detailData.row.express_type === 12 ? 8 : 24">
                                <el-form-item>
                                    <el-input
                                        v-model="detailData.row.express_number"
                                        placeholder="运单号"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" v-if="detailData.row.express_type === 12">
                                <el-form-item>
                                    <el-input
                                        v-model="detailData.row.express_phone"
                                        placeholder="查货电话"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item>
                            <el-button
                                type="primary"
                                size="small"
                                :loading="detailData.loading.submit"
                                @click="SubmitlDetail('detailData')"
                                >保 存</el-button
                            >
                            <el-button size="small" @click="detailParam.visible = false"
                                >取 消</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
export default {
    inject: ['reload'],
    props: ['detailParam'],
    data() {
        return {
            detailData: {
                loading: {
                    main: false,
                    submit: false
                },
                title: '订单发货',
                row: {
                    express_type: null,
                    express_name: null,
                    express_phone: null,
                    express_number: null
                }
            }
        }
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {})
    },
    methods: {
        SubmitlDetail(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.detailData.loading.submit = true
                    this.$request({
                        url: '/api/v1/order_deliver',
                        params: {
                            ...this.detailParam.row,
                            ...this.detailData.row
                        }
                    }).then(res => {
                        this.detailData.loading.submit = false
                        if (!res.status) {
                            this.StateOrder()
                        } else {
                            this.$message({
                                message: res.message || '操作失败',
                                type: 'error'
                            })
                        }
                    })
                }
            })
        },
        StateOrder() {
            this.$request({
                url: '/api/v1/order_status',
                params: {
                    ...this.detailParam.row,
                    status: 4
                }
            }).then(res => {
                this.$message({
                    message: res.message || (res.status ? '操作失败' : '操作成功'),
                    type: res.status ? 'error' : 'success'
                })
                if (!res.status) {
                    this.detailParam.visible = false
                    this.$parent.GetOrder()
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
</style>
